import { useState } from 'react';

export const usePagination = () => {
  const [countPage, setCountPage] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    window.scrollTo(0, 0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return {
    countPage,
    page,
    setPage,
    setCountPage,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  };
};
